<script lang="ts">
	import { siteTitle } from '$lib/stores/nav';

	import { onMount } from 'svelte';

	onMount(() => {
		$siteTitle = 'Datenschutz';
	});
</script>

<div class="mt-4">
	<h1 class="text-4xl mb-10">Datenschutz</h1>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h2>Verantwortliche</h2>
		<div class="rte">
			<p>
				Folgende Informationen gemäß Art. 13 Datenschutz-Grundverordnung (DSGVO) werden von
				folgender Verantwortlichen bereitgestellt:
			</p>
			<p>
				<a
					href="https://www.wien.gv.at/advuew/internet/AdvPrSrv.asp?Layout=stelle&Type=K&stellecd=1995060914095829"
					target="_blank"
					rel="noreferrer">Magistratsabteilung 9 - Wienbibliothek im Rathaus</a
				><br />
				E-Mail: <a href="mailto:post@ma09.wien.gv.at">post@ma09.wien.gv.at</a>
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Zwecke und Rechts&shy;grundlagen der Verarbeitung</h2>
		<div class="rte">
			<p>
				Bitte beachten Sie, dass die von Ihnen bekannt gegebenen personenbezogenen Daten von
				der oben angeführten Verantwortlichen für folgende Zwecke aufgrund folgender
				Rechtsgrundlagen verarbeitet werden:
			</p>
		</div>
	</section>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h3>Zweck</h3>
		<div class="rte">
			<p>
				Die Daten werden für den Zweck der Erfassung von Metadaten auf Theaterzetteln
				verarbeitet. Die Wienbibliothek im Rathaus stellt Theaterzettel aus ihrem Bestand
				aus den Jahren 1930-1939 digital zur Verfügung. Die Theaterzettel sind alle
				urheberrechtsfrei und werden online zum Zwecke der Erfassung der darauf befindlichen
				Informationen zur Verfügung gestellt. Personen, die sich am Crowdsourcing der
				Wienbibliothek im Rathaus beteiligen, melden sich mit einem Usernamen und Passwort
				auf der Website des Projekts an. Dafür muss eine E-Mailadresse angegeben werden.
				Nach Erstellung eines Benutzer*innen-Kontos und Anmeldung kann an der
				Crowdsourcing-Aktion teilgenommen werden. Die Wienbibliothek im Rathaus informiert
				die Benutz*innen zudem via angegebener E-Mail-Adresse über Neuigkeiten und
				begleitende Veranstaltungen wie Workshops im Rahmen des Projekts.
			</p>
		</div>
	</section>

	<section class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7">
		<h3>Rechtsgrundlage</h3>
		<div class="rte">
			<p>
				Geschäftseinteilung für den Magistrat der Stadt Wien - GEM (Wissenschaftliche
				Bearbeitung und Auswertung des gesammelten Materials sowie Forschungen zur Wiener
				Kulturgeschichte und Publikation der Forschungsergebnisse), idgF;
			</p>
			<p>Einwilligung der betroffenen Person gemäß Art. 6 Abs. 1 lit. a DSGVO</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Register&shy;abfragen</h2>
		<div class="rte">
			<p>Im Zuge der Verarbeitung werden keine Registerabfragen durchgeführt.</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Übermittlung von personen&shy;bezogenen Daten</h2>
		<div class="rte">
			<p>
				Die Crowdsourcing-Plattform ist eine Kooperation zwischen Wien Museum und
				Wienbibliothek im Rathaus. Die personenbezogenen Daten werden im Auftrag und
				Interesse der Wienbibliothek im Rathaus zum Zweck des Hostings an das Wien Museum
				als Auftragsverarbeiterin iSd Art. 4 Z 8 DSGVO weitergeleitet.
			</p>
			<p>
				Eine Übermittlung an Drittländer im Sinne des Art. 44 DSGVO (Staaten, die nicht
				Mitglied in der Europäischen Union oder im Europäischen Wirtschaftsraum sind) findet
				nicht statt.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Hinweis</h2>
		<div class="rte">
			<p>
				Sie sind nicht verpflichtet, Ihre personenbezogenen Daten bereitzustellen. Die
				Mitarbeit am Crowdsourcing-Projekt kann aber nur nach Registrierung erfolgen. Für
				die Registrierung ist die Bekanntgabe personenbezogener Daten (E-Mail-Adresse,
				Username und Passwort) notwendig.
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Betroffenen&shy;rechte</h2>
		<div class="rte">
			<p>
				Als betroffene Person haben Sie das Recht auf Auskunft über die Sie betreffenden
				personenbezogenen Daten sowie auf Berichtigung, Löschung oder Einschränkung der
				Verarbeitung oder auf Widerspruch gegen die Verarbeitung.
			</p>
			<p>
				Sie haben das Recht, Ihre Einwilligung jederzeit zu widerrufen. Wir weisen aber
				darauf hin, dass die Verarbeitung aufgrund der Einwilligung bis zum Widerruf
				rechtmäßig war.
			</p>
			<p>
				Wenn Sie der Auffassung sind, dass Ihren Rechten nicht oder nicht ausreichend
				nachgekommen wird, haben Sie die Möglichkeit einer Beschwerde bei der <a
					href="https://www.dsb.gv.at/"
					target="_blank"
					rel="noreferrer">Österreichischen Datenschutzbehörde</a
				>:
			</p>
			<p>
				Barichgasse 40-42, 1030 Wien<br />
				E-Mail: <a href="mailto:dsb@dsb.gv.at">dsb@dsb.gv.at</a>
			</p>
		</div>
	</section>

	<section
		class="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,4fr)_minmax(0,1fr)] gap-3 py-7 border-t"
	>
		<h2>Datenschutz&shy;beauftragte*r</h2>
		<div class="rte">
			<p>
				Für Fragen zum Datenschutz steht Ihnen der*die Datenschutzbeauftragte*r der Stadt
				Wien unter <a href="mailto:datenschutzbeauftragter@wien.gv.at"
					>datenschutzbeauftragter@wien.gv.at</a
				> zur Verfügung.
			</p>
		</div>
	</section>
</div>
